import dayjs from "dayjs";

import type { PayMetrics, ScheduleBlock, ScheduleResponse } from "./types";

import { BUSINESS_TIMEZONE } from "./businessDay";
import { METRIC_KEYS } from "./metricKeys";

function yesterday(): string {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    d.setHours(11, 30, 0, 0);
    return d.toISOString();
}

export function getMockPayMetrics(): PayMetrics {
    const ts = yesterday();
    return {
        createdOn: ts,
        modifiedOn: ts,
        totals: {
            serve: {
                [METRIC_KEYS.serve.ERP]: { calc: 92.25, payout: 475 }, // ERP 0–100%
                [METRIC_KEYS.serve.CRT]: { calc: 1350, payout: 0 }, // CRT in seconds
            },
            solve: {
                [METRIC_KEYS.solve.TRANSFER_RATE]: { calc: 0.04, payout: 0 }, // decimal fraction (0.04 = 4%)
                [METRIC_KEYS.solve.OCR]: { calc: 0.84, payout: 0 }, // decimal fraction (0.84 = 84%)
            },
            sell: { [METRIC_KEYS.sell.NET_ENROLLS]: { calc: 2, payout: 150 } }, // net count
        },
        clients: {},
    };
}

/** Fake schedule that non-prod shows when the API doesn't return a shift. Matches what the backend returns. */
export function getMockSchedule(date: string): ScheduleResponse {
    // Build UTC ISO strings from business-tz wall-clock times so the mock displays at the expected times.
    const at = (time: string) => dayjs.tz(`${date} ${time}`, BUSINESS_TIMEZONE).utc().toISOString();
    const available = (start: string, end: string, durationMinutes: number): ScheduleBlock => ({
        startTime: at(start),
        endTime: at(end),
        status: "AVAILABLE",
        durationMinutes,
        label: "",
        displayLabel: "Serve, Solve, Sell",
    });
    return {
        employeeId: "mock-employee",
        date,
        workStart: at("09:00"),
        workEnd: at("18:00"),
        blocks: [
            available("09:00", "10:45", 105),
            {
                startTime: at("10:45"),
                endTime: at("11:00"),
                status: "BREAK",
                durationMinutes: 15,
                label: "BRK1",
                displayLabel: "Break",
            },
            available("11:00", "12:30", 90),
            {
                startTime: at("12:30"),
                endTime: at("13:30"),
                status: "LUNCH",
                durationMinutes: 60,
                label: "LUNCH",
                displayLabel: "Lunch",
            },
            {
                startTime: at("13:30"),
                endTime: at("13:45"),
                status: "MEETING",
                durationMinutes: 15,
                label: "Glow Huddle",
                displayLabel: "Meeting",
            },
            available("13:45", "16:15", 150),
            {
                startTime: at("16:15"),
                endTime: at("16:30"),
                status: "BREAK",
                durationMinutes: 15,
                label: "BRK2",
                displayLabel: "Break",
            },
            available("16:30", "17:30", 60),
            {
                startTime: at("17:30"),
                endTime: at("17:45"),
                status: "UNKNOWN",
                durationMinutes: 15,
                label: "ERLYO",
                displayLabel: "Early Out",
            },
        ],
    };
}
